import { render, staticRenderFns } from "./DirectTax.vue?vue&type=template&id=40293ef9"
import script from "./DirectTax.vue?vue&type=script&lang=js"
export * from "./DirectTax.vue?vue&type=script&lang=js"
import style0 from "./DirectTax.vue?vue&type=style&index=0&id=40293ef9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports